// ============================================================================
// DANCE STUDIO CONFIGURATION
// ============================================================================
// Centralized configuration for email, social media, and app settings

// ============================================================================
// EMAIL CONFIGURATION
// ============================================================================

export const EMAIL_CONFIG = {
  // Main contact email
  CONTACT_EMAIL: import.meta.env.VITE_CONTACT_EMAIL || 'info@dancewithdrsophie.com',
  
  // Support email for technical issues
  SUPPORT_EMAIL: import.meta.env.VITE_SUPPORT_EMAIL || 'support@dancewithdrsophie.com',
  
  // Placeholder email for forms
  PLACEHOLDER_EMAIL: 'your@email.com',
  
  // Studio name
  STUDIO_NAME: import.meta.env.VITE_STUDIO_NAME || 'Dr. Sophia Mohan Dance Studio',
  
  // Studio phone
  STUDIO_PHONE: import.meta.env.VITE_STUDIO_PHONE || '+91 98765 43210'
} as const

// Email utility functions
export const getContactEmail = () => EMAIL_CONFIG.CONTACT_EMAIL
export const getSupportEmail = () => EMAIL_CONFIG.SUPPORT_EMAIL
export const getPlaceholderEmail = () => EMAIL_CONFIG.PLACEHOLDER_EMAIL
export const getStudioName = () => EMAIL_CONFIG.STUDIO_NAME
export const getStudioPhone = () => EMAIL_CONFIG.STUDIO_PHONE

// Email links
export const getContactEmailLink = () => `mailto:${EMAIL_CONFIG.CONTACT_EMAIL}`
export const getSupportEmailLink = () => `mailto:${EMAIL_CONFIG.SUPPORT_EMAIL}`

// ============================================================================
// SOCIAL MEDIA CONFIGURATION
// ============================================================================

// Social Media Configuration
export const socialMediaLinks = {
  instagram: 'https://instagram.com/sophiamohen',
  facebook: 'https://facebook.com/sophiamohen',
  youtube: 'https://www.youtube.com/@SofiiDanceFitness/videos',
  twitter: 'https://twitter.com/dancewithdrsophie',
  linkedin: 'https://linkedin.com/company/dancewithdrsophie',
  tiktok: 'https://tiktok.com/@dancewithdrsophie'
}

// Social media icons and colors for UI
export const socialMediaConfig = [
  {
    name: 'Instagram',
    href: socialMediaLinks.instagram,
    color: 'hover:text-pink-400',
    icon: 'instagram'
  },
  {
    name: 'Facebook',
    href: socialMediaLinks.facebook,
    color: 'hover:text-blue-400',
    icon: 'facebook'
  },
  {
    name: 'YouTube',
    href: socialMediaLinks.youtube,
    color: 'hover:text-red-400',
    icon: 'youtube'
  },
  {
    name: 'Twitter',
    href: socialMediaLinks.twitter,
    color: 'hover:text-blue-300',
    icon: 'twitter'
  },
  {
    name: 'LinkedIn',
    href: socialMediaLinks.linkedin,
    color: 'hover:text-blue-500',
    icon: 'linkedin'
  },
  {
    name: 'TikTok',
    href: socialMediaLinks.tiktok,
    color: 'hover:text-gray-300',
    icon: 'tiktok'
  }
]
